import i18n from 'shared/lib/i18n';

export const getDoorOpeningMethods = () => [
  {
    label: i18n.t('doors.openingMethod.callCenter'),
    value: 'call_center',
  },
  {
    label: i18n.t('doors.openingMethod.carsonApp'),
    value: 'carson_app',
  },
  {
    label: i18n.t('doors.openingMethod.textMessage'),
    value: 'text_code',
  },
  {
    label: i18n.t('doors.openingMethod.webApp'),
    value: 'web_admin',
  },
  {
    label: i18n.t('doors.openingMethod.fob'),
    value: 'fob',
  },
  {
    label: i18n.t('doors.openingMethod.carsonAppBt'),
    value: 'carson_app_bt',
  },
  {
    label: i18n.t('doors.openingMethod.concierge'),
    value: 'consierge', // there is a typo on the backend, using the correct word won't work
  },
];
